export const FIRESTORE_PRODUCTS_TABLE = "products";
export const FIRESTORE_ORDERS_TABLE = "orders";
export const FIRESTORE_DISCOUNT_CODES_TABLE = "discountCodes";
export const FIRESTORE_FEATURED_PRODUCTS_TABLE = "featuredProducts";
